import { theme } from "@tm/utility/global";
import React from "react";
import { H6TagStyle } from "./TextStyles.style";
import { usePartnerContext } from "@tm/static/partnerContext";

type Colors = typeof theme;
type ColorKey = keyof Colors;
interface H6TagProps {
  color?: Colors[ColorKey];
  children?: React.ReactNode;
  margin?: string;
}

const H6Tag: React.FC<H6TagProps> = ({ children, margin, color }) => {
  const context = usePartnerContext();
  return (
    <H6TagStyle
      context={context ? context : undefined}
      txtcolor={color}
      margin={margin}
    >
      {children}
    </H6TagStyle>
  );
};

export default H6Tag;
